export default __webpack_public_path__ + "static/X-Logo-d74d7cef2155f5a3d688da208b2f3e73.png";